import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { JcAnswer, JcQuestion } from '@jc/basic';
import { JcRaisedButtonDirective } from '@jc/button';
import { JcButtonDirective } from '../../../jc-button/src/lib/jc-button.directive';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { JcIconButtonDirective } from '@jc/button';
import { faTimes } from '@fortawesome/pro-light-svg-icons';

@Component({
    selector: 'dialog-question',
    styles: [
        `

        `
    ],
    template: `
<div>
  <h2 mat-dialog-title> {{data.question.titel}}
    @if (data.question.closeable) {
      <button jcIconButton (click)="onCancel()" tabindex="-1" color="basic" style="float: right;">
        <fa-icon [icon]="iconTimes"></fa-icon>
      </button>
    }
  </h2>
  <hr>
    <mat-dialog-content style="display: flex; white-space: pre-wrap;">{{data.question.text}}</mat-dialog-content>
    <hr>
      <mat-dialog-actions>
        @for (answer of this.data.question.answers; track answer) {
          @if (answer != null && !answer.raised) {
            <button jcButton [color]="answer.color" (click)="callFunction(answer); this.dialogRef.close();">
              {{ answer.titel }}
            </button>
          }
          @if (answer != null && answer.raised) {
            <button jcRaisedButton [color]="answer.color" (click)="callFunction(answer); this.dialogRef.close();">
              {{ answer.titel }}
            </button>
          }
          @if (answer == null) {
            <div class="spacer"></div>
          }
        }
      </mat-dialog-actions>
    </div>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogModule, JcIconButtonDirective, FontAwesomeModule, JcButtonDirective, JcRaisedButtonDirective]
})

export class DialogQuestionComponent {
  iconTimes = faTimes;

  constructor(
    public dialogRef: MatDialogRef<DialogQuestionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { question: JcQuestion },
  ) {
    dialogRef.disableClose = true;
  }

  public callFunction(a: JcAnswer) {
    a.func();
  }

  public onCancel() {
    this.dialogRef.close();
  }
}
